import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule  } from 'ngx-toastr';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigService } from './services/config.service';
import { AppGridModule } from './shared/components/appgrid/appgrid.module';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { BrowserCacheLocation, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalService } from '@azure/msal-angular';
import {LocationStrategy, HashLocationStrategy, DatePipe} from '@angular/common';
import { environment } from 'src/environments/environment';
import { ApiHttpService } from './services/api-http.service';
import { UserPermissionsService } from './services/user-permissions.service';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { FilterComponent } from './home/filter/filter.component';
import { FilterService } from './home/filter/filter.service';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from "@progress/kendo-angular-inputs";
import { ChartsModule } from '@progress/kendo-angular-charts';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { PopupModule } from "@progress/kendo-angular-popup";
import { ExcelModule, GridModule } from "@progress/kendo-angular-grid";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { LabelModule } from "@progress/kendo-angular-label";
import { ExcelExportModule } from "@progress/kendo-angular-excel-export";

import 'hammerjs';
import { DashboardTextFilterComponent } from './home/dashboard/filters/dashboardtextfilter.component';
import { DashboardBooleanFilterComponent } from './home/dashboard/filters/dashboardbooleanfilter.component';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export function configFactory(configService: ConfigService) {
  return () => configService.load();
}

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    DashboardComponent,
    FilterComponent,
    DashboardTextFilterComponent,
    DashboardBooleanFilterComponent
  ],
  imports: [
    AppRoutingModule,
    AppGridModule,
    GridModule,
    ExcelModule,
    HttpClientModule,
    BrowserModule,
    LayoutModule,
    DialogModule,
    ButtonsModule,
    LabelModule,
    AngularDualListBoxModule,
    BrowserAnimationsModule,
    MsalModule.forRoot( new PublicClientApplication({
      auth: {
        clientId: environment.clientID,
        authority: environment.authority,
        redirectUri: environment.redirectUri,
        postLogoutRedirectUri: environment.redirectUri
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: environment.storeAuthStateInCookie,
      }
    }), {
      interactionType: InteractionType.Redirect,
      authRequest: {
          scopes: [environment.defaultScope, 'User.Read', 'Group.Read.All'],
          prompt: 'select_account'
      }
  }, {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([ [`${environment.apiURL}${environment.apiBaseURL}/*`, [environment.defaultScope]] ])
  }),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-left'
    }), // ToastrModule added
    DropDownsModule,
    DateInputsModule,
    ChartsModule,
    ExcelExportModule,
    InputsModule,
    FormsModule,
    PopupModule,
    ButtonsModule,
    ReactiveFormsModule
  ],
  providers: [
    DatePipe,
    ConfigService,
    FilterService,
    ApiHttpService,
    UserPermissionsService,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    MsalGuard,
    MsalService,
    MsalBroadcastService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
